import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home'
import Employee from '../pages/Employee'

import EmployeeList from '../pages/Employee/EmployeeList'
import Detail from '../pages/Employee/Detail'
import EmployeeSeminar from '../pages/EmployeeSeminarInfo/index.vue'
import EmployeeSeminarInfo from '../pages/EmployeeSeminarInfo/List/index.vue'
import EmployeeSeminarInfoDetail from '../pages/EmployeeSeminarInfo/Detail'
import Group from '../pages/Group'

import ManageAccount from '../pages/ManageAccount'
import LoginAccounts from '../pages/ManageAccount/LoginAccounts'

import ForgotPassword from '../pages/forgot-password'
import ResetPassword from '../pages/reset-password'
import Page403 from '../pages/403'

import Login from '../pages/login'

import qs from 'qs'
import { multiGuards } from './multi-guards'
import { isNotLogin, isLogin } from './auth.guard'
import { canEnterModule } from './access.guard'
import CourseReport from '../pages/CourseReport/index.vue'
import CourseReportManagement from '../pages/CourseReport/Management'
import CourseReportDetail from '../pages/EmployeeSeminarInfo/Questionnaire/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: multiGuards([isNotLogin]),
    meta: {
      fullPage: true
    }
  },
  {
    path: '/homepage',
    name: 'Home',
    component: Home,
    beforeEnter: multiGuards([isLogin, [canEnterModule, 'home']]),
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee,
    redirect: { name: 'EmployeeList'},
    beforeEnter: multiGuards([isLogin]),
    children: [
      {
        path: '/',
        name: 'EmployeeList',
        component: EmployeeList,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'employees']]),
      },
      {
        path: ':id',
        name: 'Detail',
        component: Detail,
        props: true,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'employee-detail']]),
      }
    ]
  },
  {
    path: '/employee-seminar-info',
    name: 'EmployeeSeminar',
    component: EmployeeSeminar,
    redirect: { name: 'EmployeeSeminarInfo'},
    beforeEnter: multiGuards([isLogin]),
    children: [
      {
        path: '/',
        name: 'EmployeeSeminarInfo',
        component: EmployeeSeminarInfo,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'employee-seminar-info']]),
      },
      {
        path: '/detail/:id',
        name: 'EmployeeSeminarInfoDetail',
        component: EmployeeSeminarInfoDetail,
        props: true,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'employee-seminar-info']]),
      },
      {
        path: ':seminar_id/customer/:customer_id/flg/:fc_flg',
        name: 'CourseReportDetail',
        component: CourseReportDetail,
        props: true,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'course-report-detail']]),
      }
    ]
  },
  {
    path: '/course-report',
    name: 'CourseReport',
    component: CourseReport,
    redirect: { name: 'CourseReportManagement'},
    beforeEnter: multiGuards([isLogin]),
    children: [
      {
        path: '/',
        name: 'CourseReportManagement',
        component: CourseReportManagement,
        beforeEnter: multiGuards([isLogin, [canEnterModule, 'employee-course-report']]),
      }
    ]
  },
  {
    path: '/login-account',
    name: 'ManageAccount',
    component: ManageAccount,
    redirect: { name: 'LoginAccounts'},
    beforeEnter: multiGuards([isLogin, [canEnterModule, 'login-account']]),
    children: [
      {
        path: '/',
        name: 'LoginAccounts',
        component: LoginAccounts
      },
    ]
  },
  {
    path: '/group',
    name: 'Group',
    component: Group,
    beforeEnter: multiGuards([isLogin, [canEnterModule, 'group']]),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    beforeEnter: multiGuards([isNotLogin]),
    meta: {
      fullPage: true
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      fullPage: true
    }
  },
  {
    path: '/no-access-403',
    name: 'Page403',
    component: Page403,
    meta: {
      fullPage: true
    }
  },
  {
    path: '*',
    redirect: { name: 'Home' }
  }
]

export default new VueRouter({
  // mode setting
  mode: 'history',
  routes: routes,

  /**
     * @desc Helper Function to correctly deserialize http query params
     * @param query
     * @returns {any}
     */
  parseQuery(query) {
    return qs.parse(query)
  },

  /**
     * @desc Helper Function to correctly serialize data to http query param
     * @param query
     * @returns {string|string}
     */
  stringifyQuery(query) {
    const result = qs.stringify(query)
    return result ? ('?' + result) : ''
  }
})
